var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8328 12.1672C17.6099 11.9443 17.2484 11.9443 17.0255 12.1672L14.2894 14.9033L11.5533 12.1672C11.3304 11.9443 10.9689 11.9443 10.746 12.1672C10.5231 12.3901 10.5231 12.7516 10.746 12.9745L13.4821 15.7106C13.928 16.1565 14.6509 16.1565 15.0967 15.7106L17.8328 12.9745C18.0557 12.7516 18.0557 12.3901 17.8328 12.1672Z",
    fill: "#1A1C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircleWhite);
export default __webpack_public_path__ + "static/media/arrow-down-circle-white.85c954ce39428fe0f643faf0c00b8a4d.svg";
export { ForwardRef as ReactComponent };